import React, { memo, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import usePageContent from '../../hooks/usePageContent';
import StoreSellerProductsList from './StoreSellerProductsList';
import useProductCategory from '../../hooks/useProductCategory';
import useProductList from '../../hooks/useProductList';
import { useAppConfig } from '../../context/AppConfigContext';
import { generateThousandSeparator } from '../../utils/string-manipulator';
import { formatCurrency } from '../../constants';
import { Eye } from '@phosphor-icons/react';
import { Stack } from 'react-bootstrap';

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const SortPillButtons = ({ sortBy, setSortBy, productCategory, filterCategoryId, setFilterCategoryId }) => {
    const pillStyle = (active) => ({
        minWidth: '72px',
        padding: '10px 16px',
        borderRadius: '999px',
        border: 'none',
        backgroundColor: active ? '#8a1c1c' : '#ffffff',
        color: active ? '#ffffff' : '#5f5f5f',
        fontWeight: 600,
        lineHeight: 1,
        transition: 'all 0.2s ease-in-out',
        whiteSpace: 'nowrap',
        flexShrink: 0
    });

    const selectedCategory = Array.isArray(productCategory) ? productCategory.find((item) => item.id === filterCategoryId) : null;

    return (
        <Stack direction="horizontal" gap={6} className="flex-nowrap">
            <button type="button" style={pillStyle(sortBy === 'popular')} onClick={() => setSortBy('popular')}>
                Popular
            </button>

            <button type="button" style={pillStyle(sortBy === 'newest')} onClick={() => setSortBy('newest')}>
                Newest
            </button>

            {selectedCategory && (
                <>
                    <div className="vr mx-2" style={{ height: '24px', alignSelf: 'center', backgroundColor: '#e6e6e6' }}></div>
                    <button type="button" style={pillStyle(true)} onClick={() => setFilterCategoryId(undefined)}>
                        {selectedCategory.name} <i className="ph ph-x ms-1" style={{ fontSize: '12px', verticalAlign: 'middle' }} />
                    </button>
                </>
            )}
        </Stack>
    );
};

const SellerStoreProduct = ({ storeId, productCategory, categoryId }) => {
    const [products, setProducts] = useState([]);
    const [page, setPage] = useState(0);
    const [isLastPage, setIsLastPage] = useState(false);
    const [isFirstPage, setIsFirstPage] = useState(true);
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth <= 575;
    });

    const [sortBy, setSortBy] = useState('name-asc');

    let [grid, setGrid] = useState(false);
    let [active, setActive] = useState(false);

    const { lang } = useParams();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const { fetchPageContent, data, status, error, resetStatus } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: 'home', field: 'HotDealsToday', language: 'en-US' });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === '' ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    //nav pindah kesini

    const [filterCategoryId, setFilterCategoryId] = useState(categoryId);

    const handleSortChange = (newSort) => {
        setSortBy(newSort);
        setPage(0);
        setProducts([]);
    };

    const handleCategoryChange = (newCat) => {
        setFilterCategoryId(newCat);
        setPage(0);
        setProducts([]);
    };

    useEffect(() => {
        handleCategoryChange(categoryId);
    }, [categoryId]);

    const [field, direction] = sortBy.includes('-') ? sortBy.split('-') : [sortBy, undefined];

    // const {
    //     fetchProductCategory,
    //     fetchProductCategoryByUser,
    //     fetchProductCategoryByShop,
    //     data: productCategory,
    //     status: productCategoryStatus,
    //     error: productCategoryError,
    // } = useProductCategory();

    const {
        fetchProductList,
        data: productList,
        total: productListTotal,
        status: productListStatus,
        error: productListError
    } = useProductList();

    // useEffect(() => {
    //     // fetchProductCategory();
    //     fetchProductCategoryByShop(storeId.storeId);

    // }, [storeId.storeId]);

    //console.log(productCategory)

    const setSelectedGallery = (id) => {
        handleCategoryChange(id);
    };

    const setAllCategory = () => {
        handleCategoryChange(undefined);
    };

    useEffect(() => {
        if (!storeId) return;
        // console.log("check fetching categoryid", filterCategoryId);
        fetchProductList({
            companyId: storeId,
            categoryIds: filterCategoryId,
            sortBy: sortBy.split('-')[0],
            sortType: sortBy === 'popular' || sortBy === 'newest' ? 'desc' : sortBy.split('-')[1],
            // skip: page,
            skip: page * 20,
            take: 20
        });
    }, [filterCategoryId, page, storeId, sortBy]);

    useEffect(() => {
        if (productListStatus === 'done' && productList) {
            setIsLastPage(page + 1 >= Math.ceil(productListTotal / 20));
            setIsFirstPage(page === 0);

            if (page === 0) {
                setProducts(productList);
            } else {
                setProducts((prev) => {
                    const newProducts = productList.filter((newProd) => !prev.some((prevProd) => prevProd.id === newProd.id));
                    return [...prev, ...newProducts];
                });
            }
        }
    }, [productListStatus, productList, page, productListTotal]);

    useEffect(() => {
        if (isLastPage || productListStatus === 'loading' || products.length === 0) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prevPage) => prevPage + 1);
                }
            },
            { threshold: 0.1 }
        );

        const sentinel = document.getElementById('infinite-scroll-sentinel');
        if (sentinel) {
            observer.observe(sentinel);
        }

        return () => {
            if (sentinel) {
                observer.unobserve(sentinel);
            }
        };
    }, [isLastPage, productListStatus, products.length]);

    let sidebarController = () => {
        setActive(!active);
    };

    // console.log("productList data displayed" , productList)

    //nav function

    const spinKeyframes = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        .infinite-spinner {
            display: inline-block;
            animation: spin 1s linear infinite;
        }
    `;

    return (
        <section className="sellerstore-products">
            <style>{spinKeyframes}</style>
            <div className="container container-md">
                <div className="row">
                    <div className="col-12">
                        <div className="section-heading py-10 px-16" style={{ borderRadius: 0 }}>
                            <div className="d-flex justify-content-sm-between flex-wrap  flex-md-no-wrap gap-8 h-100">
                                <div className="sortHeader" style={{ maxWidth: '100%', overflowX: 'auto', scrollbarWidth: 'none' }}>
                                    <SortPillButtons
                                        sortBy={sortBy}
                                        setSortBy={handleSortChange}
                                        productCategory={productCategory}
                                        filterCategoryId={filterCategoryId}
                                        setFilterCategoryId={handleCategoryChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container container-md">
                <div className="row">
                    <div className="col-12">
                        <div className="row g-12">
                            <div className="col-md-12">
                                {/* <StoreSellerProductsList product={productList} /> */}
                                <div className="col-xxl-12 col-lg-12" style={{ position: 'relative' }}>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '0',
                                            left: '0',
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: '#fff',
                                            //backgroundColor: "rgba(0, 0, 0, 0.5)",
                                            zIndex: '999',
                                            display: productListStatus === 'loading' && page === 0 ? 'block' : 'none'
                                        }}
                                    >
                                        <img
                                            src="assets/images/icon/preloader.gif"
                                            style={{
                                                position: 'absolute',
                                                top: '0',
                                                left: '50%',
                                                marginTop: '100px',
                                                transform: 'translate(-50%, -50%)'
                                            }}
                                            alt=""
                                        />
                                    </div>
                                    <div className="flex-between gap-16 flex-wrap mb-40 ">
                                        {productListTotal > 0 ? (
                                            <>
                                                <span className="text-gray-900 text-md">
                                                    Showing {products.length} of {productListTotal} results
                                                </span>
                                                <div className="position-relative flex-align gap-16 flex-wrap">
                                                    <div className="list-grid-btns flex-align gap-16">
                                                        <button
                                                            onClick={() => setGrid(true)}
                                                            type="button"
                                                            className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                                                                grid === true && 'border-main-600 text-white bg-main-one-600'
                                                            }`}
                                                        >
                                                            <i className="ph-bold ph-list-dashes" />
                                                        </button>
                                                        <button
                                                            onClick={() => setGrid(false)}
                                                            type="button"
                                                            className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                                                                grid === false && 'border-main-600 text-white bg-main-one-600'
                                                            }`}
                                                        >
                                                            <i className="ph ph-squares-four" />
                                                        </button>
                                                    </div>
                                                    <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                                                        <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                                                            Sort by:{' '}
                                                        </label>
                                                        <select
                                                            value={sortBy}
                                                            // defaultValue={"name-asc"}
                                                            className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                                                            id="sorting"
                                                            onChange={(e) => handleSortChange(e.target.value)}
                                                        >
                                                            <option value={'name-asc'}>Name A-Z</option>
                                                            <option value={'name-desc'}>Name Z-A</option>
                                                            <option value={'price-asc'}>Lowest Price</option>
                                                            <option value={'price-desc'}>Highest Price</option>
                                                            <option value={'popular-desc'}>Popular</option>
                                                            <option value={'newest'}>Newest</option>
                                                        </select>
                                                    </div>
                                                    <button
                                                        onClick={sidebarController}
                                                        type="button"
                                                        className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                                                    >
                                                        <i className="ph-bold ph-funnel" />
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <span className="text-gray-900">No Product Found</span>
                                        )}
                                    </div>
                                    <div className={`list-grid-wrapper ${grid && 'list-view'}`}>
                                        {Array.isArray(products) &&
                                            products.length > 0 &&
                                            products.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2"
                                                >
                                                    <Link
                                                        to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                        className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                                                    >
                                                        {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                                            <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                                                                Sale {Number(item?.discount)?.toFixed(0)?.toLocaleString('en-US')}%
                                                            </span>
                                                        )}

                                                        <img
                                                            src={
                                                                item.photoData && item.photoData.length > 0
                                                                    ? item.photoData[0].url + '?width=225'
                                                                    : '/assets/images/no-image.png'
                                                            }
                                                            alt=""
                                                        />
                                                    </Link>
                                                    <div className="product-card__content w-100">
                                                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                            <Link
                                                                to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                                className="link text-line-2"
                                                                tabIndex={0}
                                                            >
                                                                {item.name || ''}
                                                            </Link>
                                                        </h6>
                                                        <div className="product-card__price my-10 d-flex flex-align gap-4">
                                                            {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                                    {/* {Number(item?.price)
                                                                            ?.toFixed(2)
                                                                            ?.toLocaleString("en-US")} */}
                                                                    {formatCurrency(item?.price)}{' '}
                                                                </span>
                                                            )}
                                                            <span className="text-heading text-md fw-semibold d-flex flex-grow-1">
                                                                {/* {Number(
                                                                    item?.discountPrice > 0 &&
                                                                        item?.discountPrice < item?.price
                                                                        ? item?.discountPrice
                                                                        : item?.price
                                                                )
                                                                    ?.toFixed(2)
                                                                    ?.toLocaleString("en-US")}{" "} */}
                                                                {generateThousandSeparator(
                                                                    formatCurrency(
                                                                        item?.discountPrice > 0 && item?.discountPrice < item?.price
                                                                            ? item?.discountPrice
                                                                            : item?.price
                                                                    ).toString()
                                                                )}{' '}
                                                                {/* <span className="text-gray-500 fw-normal">/Qty</span>{' '} */}
                                                            </span>
                                                            <span className="text-gray-500 fw-normal d-flex flex-align gap-4">
                                                                <Eye size={16} /> {item?.viewCount}
                                                            </span>{' '}
                                                        </div>
                                                        <Link
                                                            to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                            className="product-card__cart btn bg-main-one-50 text-heading hover-bg-main-one-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                                                            tabIndex={0}
                                                        >
                                                            View Detail
                                                        </Link>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>

                                    {productListTotal > 0 && !isLastPage && (
                                        <div id="infinite-scroll-sentinel" style={{ height: '20px', margin: '20px 0' }} />
                                    )}

                                    {productListStatus === 'loading' && page > 0 && (
                                        <div className="d-flex justify-content-center my-4 py-4 w-100 align-items-center gap-2">
                                            <i
                                                className="ph ph-spinner-gap infinite-spinner text-main-one-600"
                                                style={{ fontSize: '32px' }}
                                            />
                                            <span className="text-gray-600 fw-semibold text-md">Loading more products...</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SellerStoreProduct;
